import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import React, { useState, useEffect } from 'react';






import { Select, Button } from "./..";

import clsx from 'clsx';
import SIC2Codes from "../../assets/SIC2Codes.json";
import SIC4Codes from "../../assets/SIC4Codes.json";
import { createStyles } from "./styles";

var INITIAL_SIC_CODES_OBJECT = _Object$freeze({ sic2: '', sic4: '' });

var SICSelect = function SICSelect(props) {
  // Props
  var _props$disabled =









    props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled,onUpdateValCallback = props.onUpdateValCallback,onEdit = props.onEdit,validationPassed = props.validationPassed,validationMessage = props.validationMessage,defaultSic2 = props.defaultSic2,defaultSic4 = props.defaultSic4,guidelines = props.guidelines,showGuidelinesByDefault = props.showGuidelinesByDefault;

  // React state
  function buildInitial() {
    if (defaultSic2 && defaultSic4) {
      return { sic2: defaultSic2, sic4: defaultSic4 };
    }
    if (defaultSic4 && defaultSic4.length > 0) {
      // if only sic4 passed, we should set both values
      var sic2 = defaultSic4.length > 0 ? defaultSic4.substr(0, 2) : '';
      return { sic2: sic2, sic4: defaultSic4 };
    }
    return _objectSpread({},
    INITIAL_SIC_CODES_OBJECT);

  }

  var _useState = useState(buildInitial()),_useState2 = _slicedToArray(_useState, 2),sicCodes = _useState2[0],setSicCodes = _useState2[1];

  // Component actions
  function getSic2Options() {
    return _mapInstanceProperty(SIC2Codes).call(SIC2Codes, function (code) {var _context;return { label: _concatInstanceProperty(_context = "".concat(code.id, " - ")).call(_context, code.description), value: code.id };});
  }

  function getSic4Options(selectedSic2Code) {var _context2;
    return _mapInstanceProperty(_context2 = _filterInstanceProperty(SIC4Codes).call(SIC4Codes, function (code) {return code.sic2Code === selectedSic2Code;})).call(_context2, function (code) {var _context3;return {
        label: _concatInstanceProperty(_context3 = "".concat(code.id, " - ")).call(_context3, code.description),
        value: code.id
      };});
  }

  function getSicDataInString(
  codeId,
  codesToSearch)
  {var _context4;
    var codeInfo = _findInstanceProperty(codesToSearch).call(codesToSearch, function (code) {return code.id === codeId;});
    return _concatInstanceProperty(_context4 = "".concat(codeId, " - ")).call(_context4, codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.description);
  }

  function onSicCodeChange(e) {
    setSicCodes(function (prevVal) {
      var newVal = _objectSpread(_objectSpread({}, prevVal), {}, _defineProperty({}, e.target.name, e.target.value));
      if (e.target.name === 'sic2') {
        newVal.sic4 = '';
      }
      return newVal;
    });
  }

  // React effects
  useEffect(function () {
    if (onUpdateValCallback && sicCodes.sic2.length > 0) {
      onUpdateValCallback({
        sic2: getSicDataInString(sicCodes.sic2, SIC2Codes),
        sic4: sicCodes.sic4 ? getSicDataInString(sicCodes.sic4, SIC4Codes) : ''
      });
    }
  }, [sicCodes.sic2, sicCodes.sic4]);

  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.outerWrapper }, /*#__PURE__*/
    React.createElement("div", null, /*#__PURE__*/
    React.createElement(Select, {
      name: "sic2",
      options: getSic2Options(),
      onChange: onSicCodeChange,
      value: sicCodes.sic2,
      disabled: disabled,
      className: clsx(classes.topSelect, classes.select) }), /*#__PURE__*/

    React.createElement(Select, {
      name: "sic4",
      options: getSic4Options(sicCodes.sic2),
      onChange: onSicCodeChange,
      value: sicCodes.sic4,
      disabled: disabled || sicCodes.sic2.length < 1,
      validationPassed: validationPassed,
      validationMessage: validationMessage,
      className: classes.select,
      guidelines: guidelines,
      showGuidelinesByDefault: showGuidelinesByDefault })),


    disabled && onEdit && /*#__PURE__*/
    React.createElement(Button, { onClick: onEdit, type: "text", color: "primary", className: classes.editButton }, "Edit")));





};
SICSelect.displayName = 'SICSelect';

export default SICSelect;
//# sourceMappingURL=index.js.map